import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="pt-16 pb-12 px-4 bg-slate-950 text-center" data-id="element-66">
      <div className="max-w-3xl mx-auto" data-id="element-67">
        <FadeIn data-id="element-68">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-10 leading-[1.15] tracking-tight" data-id="element-69">
            ¿Cuántas veces más vas a llegar a la subida rezando para que las
            piernas aguanten?
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-70">
          <div className="relative w-full max-w-md mx-auto mb-10" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/72sxExrU2iFdew4rEVxBCe/heylloyd-image-1773462204816.png" alt="Protorrenda 4-12 — Método de entrenamiento para ciclistas amateurs argentinos. Pack de 6 tomos + 2 bonos." className="w-full h-auto rounded-2xl shadow-2xl" width={665} height={363} loading="eager" fetchPriority="high" decoding="async" data-id="element-72" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-73">
          <p className="text-xl md:text-2xl text-slate-400 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-74">
            Hay ciclistas que llegan arriba con el grupo. Y hay ciclistas que
            esperan que los esperen.{' '}
            <span className="text-amber-500 font-bold italic" data-id="element-75">
              La diferencia es un sistema.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}